import { TypedUseSelectorHook, useSelector } from 'react-redux';

// Store.
import { AppState } from 'store';

export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
